import kwelloLogoMenu from 'assets/icons/kwelloLogoMenu.svg?url';
import PropTypes from 'prop-types';

export const KwelloWhiteLogo = ({ className }) => (
  <img src={kwelloLogoMenu} className={className} />
);

KwelloWhiteLogo.propTypes = { className: PropTypes.string };
KwelloWhiteLogo.defaultProps = { className: null };
